import React, { useState } from "react";
import { Popover, Box } from "@mui/material";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import BlockIcon from "@mui/icons-material/Block";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";


import {
  AccessTime,
  Event,
  Label,
  Person,
  CheckCircle,
  HourglassEmpty,
  PauseCircle,
  RadioButtonUnchecked,
  FiberManualRecord,
} from "@mui/icons-material"

const StatusPopover = ({ task_status }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const getStatusIcon = (status) => {
    switch (status) {
      case 1:
        return <RadioButtonUnchecked sx={iconStyle} />;
      case 2:
        return <HourglassEmpty sx={iconStyle} />;
      case 3:
        return <PauseCircle sx={iconStyle} />;
      case 4:
        return <CheckCircle sx={iconStyle} />;
      default:
        return <MoreHorizIcon sx={iconStyle} />;
    }
  };

  const getStatusStyle = (status) => {
    return task_status === status
      ? { backgroundColor: "#ffeb3b", color: "#000000" }
      : { backgroundColor: "#e8e8e8", color: "#000000" };
  };

  const iconStyle = {
    fontSize: 18,
    color: "#000000",
    backgroundColor: "#e8e8e8",
    padding: "2px",
    borderRadius: "4px",
    cursor: "pointer",
  };

  return (
    <div>
      <div onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
        {getStatusIcon(task_status)}
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableRestoreFocus
        sx={{ pointerEvents: "none" }} // Ensures it disappears on mouse leave
      >
        <Box sx={{ padding: 1, maxWidth: 200, flexDirection: "column" }}>
          <div className="d-flex align-items-center" style={{ marginBottom: "2px" }}>
            <HourglassEmpty sx={{ fontSize: 14, padding: "1px", borderRadius: "4px", ...getStatusStyle(2) }} />
            <p className="poptext">&nbsp; In Progress</p>
          </div>

          <div className="d-flex align-items-center" style={{ marginBottom: "2px" }}>
            <PauseCircle sx={{ fontSize: 14, padding: "1px", borderRadius: "4px", ...getStatusStyle(3) }} />
            <p className="poptext">&nbsp; On Hold</p>
          </div>

          <div className="d-flex align-items-center" style={{ marginBottom: "2px" }}>
            <CheckCircle sx={{ fontSize: 14, padding: "1px", borderRadius: "4px", ...getStatusStyle(4) }} />
            <p className="poptext">&nbsp; Completed</p>
          </div>

          <div className="d-flex align-items-center" style={{ marginBottom: "2px" }}>
            <RadioButtonUnchecked sx={{ fontSize: 14, padding: "1px", borderRadius: "4px", ...getStatusStyle(1) }} />
            <p className="poptext">&nbsp; Not Started</p>
          </div>
        </Box>
      </Popover>
    </div>
  );
};

export default StatusPopover;
